export default __webpack_public_path__ + "static/media/blank-profile.d6a64ff8.png";